export default "/assets/vegan.svg";